import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'jobmonitorEasy';

const jobmonitorEasyService = {
  getProductionOperationsFromView: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/productionOperations/view`,
      data,
    });
  },

  checkOpenProductionReportByUser: (userId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/checkOpenProductionReport/${encodeURIComponent(userId)}`,
    });
  },

  getUserActiveProductions: (userId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/activeProductions/${encodeURIComponent(userId)}`,
    });
  },

  getActiveDowntime: (userId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/activeDowntime/${encodeURIComponent(userId)}`,
    });
  },

  resumeFromDowntime: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/resumeFromDowntime`,
      data,
    });
  },

  getInProgressWorks: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/inProgessWorks`,
    });
  },

  createProductionReport: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/productionreport`,
      data,
    });
  },

  closeProductionReport: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/closeProductionReport`,
      data,
    });
  },

  markFirstLogin: (userId) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/firstLogin/${encodeURIComponent(userId)}`,
    });
  },

  acceptConfidentialityAgreement: (userId) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/acceptConfidentialityAgreement/${encodeURIComponent(userId)}`,
    });
  },
};

export default jobmonitorEasyService;
